export const LogoMark = ({ size = 40 }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" role="img" aria-label="RKJ logo" data-testid="logo-mark">
    <rect width="40" height="40" rx="10" fill="#0F5132" />
    <path d="M10 13.5h7M10 18h4.5" stroke="#F7F2E8" strokeWidth="2.2" strokeLinecap="round" opacity=".65" />
    <path d="M10.5 28L17 21.5l4 2.8L29 14" stroke="#D9A83C" strokeWidth="2.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="29" cy="14" r="2.5" fill="#D9A83C" />
  </svg>
);

export const Brand = ({ light = false }) => (
  <span className={`brand ${light ? "brand-light" : ""}`}>
    <LogoMark size={38} />
    <span className="brand-text">
      <b>RKJ</b>
      <small>GST CONSULTANCY</small>
    </span>
  </span>
);
